package br.com.vvrefeicoes.portal.core.di

import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue
import br.com.vvrefeicoes.portal.core.util.guardedLoad
import org.jetbrains.compose.resources.StringResource
import portalvv.shared.generated.resources.Res
import portalvv.shared.generated.resources.app_load_error

/**
 * Estado global de erro de carga: os controllers reportam uma falha e o shell exibe um banner.
 */
class LoadErrorState {
    var current by mutableStateOf<StringResource?>(null)
        private set

    fun report(resource: StringResource) {
        current = resource
    }

    fun dismiss() {
        current = null
    }
}

/** Executa [block] e, em caso de falha, reporta o aviso padrão de carga. */
suspend fun LoadErrorState.loadGuarded(block: suspend () -> Unit): Boolean =
    guardedLoad(block).also { ok ->
        if (!ok) report(Res.string.app_load_error)
    }
